import React from "react"; // Add this line
import { Link } from "react-router-dom";
import ServicesOverview from "./ServicesOverview";

function SmartHomeSection() {
  return (
    <section className="mx-auto w-[calc(100%-2.5rem)] max-w-[1088px] mb-12 md:mb-16">
      <div className="grid items-center w-full gap-12 grid-cols-1 md:grid-cols-2 mb-16 md:mb-20 xl:mb-20 md:order-none">
        <div className="[&_p]:!text-[#17354A] [&_p]:text-base md:[&_p]:text-lg order-2 md:order-none">
          <h2 className="font-bold text-black leading-[1.25] text-[24px] lg:text-[36px] text-[#17354A] mb-4 md:mb-6">
            Groepenkast aansluiten of vervangen in Arnhem? Wij zorgen voor een
            veilige installatie!
          </h2>

          <p>
            Een moderne en veilige <strong>groepenkast</strong> is essentieel
            voor een betrouwbare stroomvoorziening in je woning of bedrijfspand
            in Arnhem. Of je nu een nieuwe groepenkast nodig hebt of je
            bestaande wilt vervangen, onze gecertificeerde elektriciens zorgen
            voor een vakkundige installatie die voldoet aan alle normen.
            <br />
            <br />
            Wij regelen alles: van het uitbreiden met extra groepen tot het
            volledig vervangen van je groepenkast. Zo ben je verzekerd van een
            veilige en toekomstbestendige elektrische installatie in Arnhem.
          </p>

          <div className="h-9"></div>
          <a
            href="/groepenkast-vervangen"
            className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-transparent items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] bg-[#F47B20] text-white hover:bg-[#F47B20]/80 focus:bg-[#F47B20]/80 focus-visible:border-crustaLight disabled:bg-[#F47B20]/40 w-full md:w-fit"
            style={{ minWidth: "216px" }}
          >
            <span className="flex items-center gap-1">
              Meer over groepenkast vervangen
            </span>
          </a>
        </div>
        <div className="order-1 md:-order-1">
          <div className="relative">
            <span className="absolute bg-[#E6B800] text-white px-2 py-1 text-xs  rounded-md opacity-20 top-1/4 right-1/3">
              elektricieninarnhem026.nl
            </span>

            <img
              alt="Slim stroom handelen met thuisbatterij"
              loading="lazy"
              width="1028"
              height="1032"
              decoding="async"
              data-nimg="1"
              src="/images/ABB.png"
              srcSet="/images/ABB.png"
              style={{ color: "transparent" }}
            />
          </div>
        </div>
      </div>

      <ServicesOverview />

      <div className="grid items-center w-full gap-12 grid-cols-1 md:grid-cols-2 mb-16 md:mb-20 xl:mb-20">
        <div className="[&_p]:!text-[#17354A] [&_p]:text-base md:[&_p]:text-lg order-2 md:order-1">
          <h2 className="font-bold text-black leading-[1.25] text-[24px] lg:text-[36px] text-[#17354A] mb-4 md:mb-6">
            Kookgroep Perilex aansluiten in Arnhem
          </h2>
          <p>
            Met onze innovatieve energieoplossingen helpen we je het maximale
            uit je elektriciteitsverbruik te halen in Arnhem. Van slimme meters
            tot geavanceerde energiemanagementsystemen, we bieden complete
            oplossingen voor zowel particulieren als bedrijven. Ontdek hoe je
            kunt besparen op je energierekening én bijdraagt aan een duurzame
            toekomst in Arnhem.
          </p>

          <div className="h-9"></div>
          <div className="flex flex-wrap gap-3">
            <Link
              to="/kookgroep-aansluiten"
              className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-transparent items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] bg-[#F47B20] text-white hover:bg-[#F47B20]/80 focus:bg-[#F47B20]/80 focus-visible:border-crustaLight disabled:bg-[#F47B20]/40 w-full md:w-fit"
              style={{ minWidth: "216px" }}
            >
              <span className="flex items-center gap-1">
                Meer over Kookgroep
              </span>
            </Link>

            {/* <a
              href="tel:+31852129778"
              className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-[#17354A] items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] text-[#17354A] hover:bg-[#E6B800] hover:text-white focus:opacity-60 w-full md:w-fit"
              style={{ minWidth: "216px" }}
            >
              <span className="flex items-center gap-1">
                <Phone className="w-4 h-4" />
                Bel direct 085-2129778
              </span>
            </a> */}
          </div>
        </div>
        <div className="order-1 md:order-2">
          <div className="relative">
            <span className="absolute bg-[#E6B800] text-white px-2 py-1 text-xs  rounded-md opacity-20 top-1/4 right-1/3">
              elektricieninarnhem026.nl
            </span>

            <img
              alt="Slim stroom handelen met thuisbatterij"
              loading="lazy"
              width="1028"
              height="1032"
              decoding="async"
              data-nimg="1"
              src="/images/perilex-kookplaat.png"
              srcSet="/images/perilex-kookplaat.png"
              style={{ color: "transparent" }}
            />
          </div>
        </div>
      </div>

      <div className="grid items-center w-full gap-12 grid-cols-1 md:grid-cols-2 mb-16 md:mb-20 xl:mb-20 md:order-none">
        <div className="[&_p]:!text-[#17354A] [&_p]:text-base md:[&_p]:text-lg order-2 md:order-none">
          <h2 className="font-bold text-black leading-[1.25] text-[24px] lg:text-[36px] text-[#17354A] mb-4 md:mb-6">
            1-fase naar 3-fase groepenkast aansluiten in Arnhem
          </h2>
          <p>
            Heb je een elektrische auto, inductiekookplaat of andere zware
            verbruikers in huis in Arnhem? Dan is een{" "}
            <strong>3-fase groepenkast</strong>
            essentieel voor een stabiele en veilige stroomvoorziening. Wij
            verzorgen de volledige installatie, van meterkast aanpassing tot
            keuring, zodat je direct zonder zorgen gebruik kunt maken van je
            apparaten.
            <br />
            <br />
            Onze gecertificeerde elektriciens zorgen voor een vakkundige
            aansluiting en denken met je mee over de beste indeling. Neem
            vandaag nog contact op voor een vrijblijvende offerte!
          </p>

          <div className="h-9"></div>
          <a
            href="/3-fase-aansluiting"
            className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-transparent items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] bg-[#F47B20] text-white hover:bg-[#F47B20]/80 focus:bg-[#F47B20]/80 focus-visible:border-crustaLight disabled:bg-[#F47B20]/40 w-full md:w-fit"
            style={{ minWidth: "216px" }}
          >
            <span className="flex items-center gap-1">
              Meer over 3-fase aansluiting
            </span>
          </a>
        </div>
        <div className="order-1 md:-order-1">
          <div className="relative">
            <span className="absolute bg-[#E6B800] text-white px-2 py-1 text-xs  rounded-md opacity-20 top-1/4 right-1/3">
              elektricieninarnhem026.nl
            </span>

            <img
              alt="Slim stroom handelen met thuisbatterij"
              loading="lazy"
              width="1028"
              height="1032"
              decoding="async"
              data-nimg="1"
              src="/images/ABB-440x390-3F.png"
              srcSet="/images/ABB-440x390-3F.png"
              style={{ color: "transparent" }}
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default SmartHomeSection;
